/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 02 2023
 **/

import { colors } from "@/frameworks/core/styles";
import { filterHTMLDataAttribute } from "@/frameworks/libraries/utilities";
import { Maybe } from "@/frameworks/libraries";

import { Badge, Button, Icon, Row } from "../../../components";
import { UserListItem } from "../index";
import { userListItemCss } from "./private/emotion";

export default function ShortDirectMessage({
	badgeList,
	avatarList = [],
	isVoiceCall,
	onMoreClick,
	isChatFeature,
	title,
	hasDraft,
	...rest
}: DesignStuff.ShortDirectMessage.Props) {
	return (
		<UserListItem
			css={userListItemCss}
			avatarList={avatarList}
			isChatFeature={isChatFeature}
			title={title}
			{...rest}
		>
			<Row gap={7} verticalAlign="center" horizonAlign="center">
				<Row
					className="more-icon"
					style={{ minWidth: "16px" }}
					gap={12}
					verticalAlign="center"
					horizonAlign="center"
				>
					<Button.Icon
						name={"More24"}
						/* @ts-ignore */
						size={"medium"}
						onClick={onMoreClick}
						{...filterHTMLDataAttribute(rest)}
					/>
					<Maybe test={badgeList?.includes("new")}>
						<Row style={{ marginRight: "10px" }} className="news-icon">
							<Badge type="mediumDot" />
						</Row>
					</Maybe>
				</Row>
				<Row className="notify-icons" verticalAlign="center" style={{ gap: "8px" }}>
					<Row style={{ minWidth: "16px" }} gap={8} verticalAlign="center" horizonAlign="center">
						<Maybe test={hasDraft}>
							<Icon name="Edit24" size={16} fill={colors.neutral_50_100} />
						</Maybe>
						<Maybe test={isVoiceCall}>
							<Icon name="VoiceChat24" size={14} fill={colors.neutral_50_100} />
						</Maybe>
						<Maybe test={badgeList?.includes("pin")}>
							<Icon name="Pin16" size={16} fill={colors.neutral_50_100} />
						</Maybe>
					</Row>
					<Maybe test={badgeList?.includes("new")}>
						<Badge type="mediumDot" />
					</Maybe>
				</Row>
			</Row>
		</UserListItem>
	);
}
